Vue.component('information', {
    data() {
        return {
            informationForm: $.extend(true, new Form({
                data: {
                    content: '',
                }
            }), {}),
        }
    },

    mounted () {
        axios.get('/api/information').then((response) => {
            this.informationForm.data.content = response.data.content;
        });

        localStorage.setItem('_last_information_read', new Date());
        $('#information-notification').hide();
    },
    methods: {
        handleSave () {
            Http.post('/api/information/save', this.informationForm);
        }
    },
});
